import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

@jsonObject
export class Timezone {

  @jsonMember({name: 'timezone'})
  public Timezone!: string;

  @jsonMember({name: 'region'})
  public Region!: string;

  get FullName(): string {
    if (this.Region !== '') {
      return `${this.Region}/${this.Timezone}`;
    } else {
      return this.Timezone;
    }
  }
}
